import { NOT_REPORTED, isUnreportedHeadcountText } from '../../helper/metricBuckets';

export function firstPresent(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== '');
}

export function firstNumber(...values) {
  const value = values.find((item) => item !== undefined && item !== null && item !== '');
  if (value === undefined) return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
}

export function safeText(value, fallback = 'N/A') {
  if (Array.isArray(value)) {
    const text = value.map((item) => safeText(item, '')).filter(Boolean).join(', ');
    return text || fallback;
  }
  if (value === undefined || value === null || value === '') return fallback;
  return String(value);
}

// A blank headcount or revenue was never reported by the source (FE #749).
export function reportedText(value) {
  return value === 'N/A' ? NOT_REPORTED : safeText(value, NOT_REPORTED);
}

// Saved artifacts can hold "<25", which straddles 1–10 and 11–50 (ETL #100).
export function reportedHeadcountText(value) {
  return isUnreportedHeadcountText(value) ? NOT_REPORTED : reportedText(value);
}

// Company descriptions can arrive as a stringified Python list ("['a', 'b']"),
// which rendered verbatim in restored cards (sweep D12). Unwrap the items;
// any other text is returned untouched.
const STRINGIFIED_LIST = /^\[\s*['"]([\s\S]*)['"]\s*\]$/;

export function listLiteralText(value) {
  if (typeof value !== 'string') return value;
  const match = value.trim().match(STRINGIFIED_LIST);
  if (!match) return value;
  return match[1]
    .split(/['"]\s*,\s*['"]/)
    .map((item) => item.replace(/\\(['"])/g, '$1').trim())
    .filter(Boolean)
    .join(' ');
}

export function formatLocation(location) {
  if (typeof location === 'string') return location;
  if (!location || typeof location !== 'object') return '';

  return [
    firstPresent(location.locality, location.city, location.hq_city),
    firstPresent(location.region, location.state, location.region1, location.hq_state),
    firstPresent(location.country, location.country_code),
  ].filter(Boolean).join(', ');
}
